import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["urlField", "fileField"]

  connect() {
    console.log('Link type selector connected')
    this.toggleFields()
  }

  toggleFields() {
    console.log('toggleFields called')
    
    const checkedRadio = this.element.querySelector('input[name="product[link_type]"]:checked')
    const urlField = this.urlFieldTarget
    const fileField = this.fileFieldTarget
    
    console.log('Checked radio:', checkedRadio)
    console.log('Checked radio value:', checkedRadio ? checkedRadio.value : 'none')
    
    // 全て非表示にする
    urlField.classList.add('hidden')
    fileField.classList.add('hidden')
    
    // 選択されたタイプに応じて表示
    if (checkedRadio && checkedRadio.value === 'external_link') {
      console.log('Showing URL field')
      urlField.classList.remove('hidden')
    } else if (checkedRadio && checkedRadio.value === 'pdf_file') {
      console.log('Showing file field')
      fileField.classList.remove('hidden')
    }
  }
}
